import { getToken } from '@core/request/token'

// 上传文件到服务器
export const uploadFileToServer = async file => {
  try {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('source', 'geo')

    const token = getToken()
    const headers = {
      'geo-source-type': localStorage.getItem('geoMode') || 'inner',
    }
    if (token) {
      headers['X-Token'] = token
      headers['x-xsrf-token'] = token
    }
    const response = await fetch(`${process.env.VUE_APP_RESOURCE_API}/file/upload`, {
      method: 'POST',
      body: formData,
      credentials: 'include',
      headers,
    })

    if (!response.ok) {
      return { filePath: '' }
    }

    const data = await response.json()
    const filePath = data?.data?.filePath || data?.data?.url || data?.filePath || data?.url
    return { filePath: filePath || '' }
  } catch {
    return { filePath: '' }
  }
}

// 文件上传处理 - 粘贴图片走服务器上传，失败时过滤掉
export const uploadHandler = blobInfo => {
  return new Promise((resolve, reject) => {
    const file = new File([blobInfo.blob()], blobInfo.filename(), {
      type: blobInfo.blob().type,
    })
    uploadFileToServer(file)
      .then(res => resolve(res.filePath || ''))
      .catch(() => resolve(''))
  })
}

// 文件选择回调
export const pickerCallback = () => {
  return (callback, value, meta) => {
    if (meta.filetype === 'file') {
      callback('https://www.google.com/logos/google.jpg', { text: 'My text' })
    }

    /* Provide image and alt text for the image dialog */
    if (meta.filetype === 'image') {
      callback('https://www.google.com/logos/google.jpg', { alt: 'My alt text' })
    }

    /* Provide alternative source and posted for the media dialog */
    if (meta.filetype === 'media') {
      callback('movie.mp4', {
        source2: 'alt.ogg',
        poster: 'https://www.google.com/logos/google.jpg',
      })
    }
  }
}
